import { inject, Injectable } from '@angular/core';

import { ReplaceableComponentsService } from '@abp/ng.core';
import { eThemeLeptonXComponents } from '@volosoft/abp.ng.theme.lepton-x';

import { NavItemsComponent } from '../components';

@Injectable({
  providedIn: 'root',
})
export class ReplaceComponentsService {
  private replaceableComponentsService = inject(ReplaceableComponentsService);

  public replaceAbpComponents(): void {
    this.replaceNavItemsComponent();
  }

  private replaceNavItemsComponent(): void {
    this.replaceableComponentsService.add({
      component: NavItemsComponent,
      key: eThemeLeptonXComponents.Breadcrumb,
    });
  }
}
